module.exports = __webpack_public_path__ + "img/avatar.53828dee.53828dee.jpg";